import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Segmented as AntSegmented } from 'antd';

/**
 * Reusable design-system wrapper around Ant Design Segmented.
 * Adds a stable class hook while retaining the native Ant Design API.
 */
const Segmented = forwardRef(({ className = '', ...props }, ref) => (
    <AntSegmented
        ref={ref}
        className={['ds-segmented', className].filter(Boolean).join(' ')}
        {...props}
    />
));

Segmented.displayName = 'Segmented';

Segmented.propTypes = {
    className: PropTypes.string,
};

export default Segmented;
